import { render } from "./OrganizationManagement.vue?vue&type=template&id=48a1e6fc"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"
script.render = render

export default script